/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
import api from "./ApiService";

const BASE_PATH = `${process.env.REACT_APP_API_BASE_URL}/Mers/WareHouseBank`;

const getWarehouseBanks = () => {
  return api.get<any>(BASE_PATH).then((response: any) => response);
};

const createWarehouseBank = (data: any) => {
  return api.post<any>(BASE_PATH, data).then((response: any) => response);
};

const updateWarehouseBank = (data: any) => {
  return api.put<any>(BASE_PATH, data).then((response: any) => response);
};

const WarehouseBankService = {
  getWarehouseBanks,
  createWarehouseBank,
  updateWarehouseBank,
};

export default WarehouseBankService;